<app-tab-bar [tabs]="tabList" [currentTab]="currentTab"
             (updateCurrentIndex)="getIndexValue($event)"></app-tab-bar>
<div class="site-content">
  <div class="section" style="padding: 0" *ngIf="response">
    <div class="section-identifier">
      <div class="index-name"> {{response.indexName}} </div>
      <span>ISIN: </span> <span>{{response.isinTri}}</span> |
      <span>Bloomberg Ticker: </span><span>{{response.bbgTickerTri}} </span>
      <span *ngIf="response?.investmentType.includes('Standardized_TRS')">| Markit RED ID: </span><span *ngIf="response?.investmentType.includes('Standardized_TRS')">{{response.redId}} </span>
      <span>| Base Date: </span><span>{{utilService.formatDate(response.baseDate)}} </span>
    </div>
    <div class="index-family-bar">
      Region: <span style="font-weight: 600" *ngIf="response.productRegion !== '(unassigned)'">{{response.productRegion.includes(',') ? 'Global' : response.productRegion}}</span>
      |
      Index Family: <span style="font-weight: 600" *ngIf="response.productName !== '(unassigned)'">{{response.productName.split(',').join(', ')}}</span>
    </div>
    <div class="section-quantifier">
      <table>
        <tr>
          <td>As Of Date</td>
          <td>Inflation Adjustment</td>
          <td>Total Return Index Level</td>
          <td>
            <span *ngIf="response.indexAnalyticsBond">Annual Yield</span>
            <span *ngIf="response.indexAnalyticsLoan">Current Yield</span>
          </td>
          <td>
            <span *ngIf="response.indexAnalyticsBond">Duration</span>
            <span *ngIf="response.indexAnalyticsLoan">Modified Duration Maturity</span>
          </td>
          <td>Number of Constituents</td>
        </tr>
        <tr>
          <td>{{this.utilService.formatDate(response.asOf)}}</td>
          <td>{{response.inflationAdjustment}}</td>
          <td>{{response.totalReturnIndex | number: '1.2-4'}}</td>
          <td>
            <span *ngIf="response.indexAnalyticsBond">{{response.indexAnalyticsBond.annualYield | number: '1.2-4'}}</span>
            <span *ngIf="response.indexAnalyticsLoan">{{response.indexAnalyticsLoan.currentYield | number: '1.2-4'}}</span>
          </td>
          <td>
            <span *ngIf="response.indexAnalyticsBond">{{response.duration | number: '1.2-4'}}</span>
            <span *ngIf="response.indexAnalyticsLoan">{{response.indexAnalyticsLoan.modifiedDurationMaturity | number: '1.2-4'}}</span>
          </td>
          <td>{{response.numberOfInstruments}}</td>
        </tr>
      </table>
    </div>
    <div style="display: flex" *ngIf="expanded">
      <div style="width: 2%; border-bottom: 8px solid #f0f1f2; padding: 8px 10px;">
        <i class="site-icon-back pointer-cursor" (click)="expandView('CHART')"></i>
      </div>
      <app-tab-bar style="width: 98%" [tabs]="cards" [dynamicTabs]="false"
                   [currentTab]="currentCard" (updateCurrentIndex)="changeView($event)"></app-tab-bar>
    </div>
  </div>
  <div class="section" *ngIf="!response">
    No data to show
  </div>
  <div class="sub-section">
    <div class="card" [hidden]="!visibleCards.includes('chart')" [ngStyle]="{'margin-top': expanded ? '0' : '10px'}">
      <div class="card-header" style="display: flex; padding: 0.5rem 1rem 0 1rem; align-items: center">
        <span> Chart </span>
        <div class="chart-options-parent">
          <div style="display: flex; margin-bottom: 5px">
            <div style="width: 150px; margin-right: 8px">
              <span>Period</span>
              <app-ihsm-dropdown-lib dropdownType="single" [data]="period" [maxItemsToChoose]="period.options.length"
                                   (filterAppliedEvent)="applyPeriodFilter()"></app-ihsm-dropdown-lib>
            </div>
            <div style="width: 230px">
              <span>Date Picker</span>
              <app-range-date-select [dateRange]="dateRange" (filterChanged)="setDateRange($event)"></app-range-date-select>
            </div>
            <div style="width: 220px;">
              <span>Timeseries</span>
              <app-ihsm-dropdown-lib dropdownType="single" [data]="timeSeries" *ngIf="response"
                                   (filterAppliedEvent)="applyTimeSeriesFilter()"></app-ihsm-dropdown-lib>
            </div>
            <div style="width: 270px; margin-left: 8px" *ngIf="response?.investmentType !== null &&
                                    (response?.investmentType.includes('Futures') ||response?.investmentType.includes('Standardized_TRS'))">
              <span>Compare Indices (Add up to four)</span>
              <app-ihsm-dropdown-lib class="multi-dropdown" *ngIf="resetDropdown" [data]="compareData" dropdownType="multi" [maxLabelsDisplay]="2"
                                   [maxItemsToChoose]="4" [enableSearch]="true" (filterAppliedEvent)="compareCharts($event)"></app-ihsm-dropdown-lib>
            </div>
          </div>
          <span class="clear-filter primary-color pointer-cursor" style="width: 80px; margin-top: 15px" (click)="resetChart()"
                [ngStyle]="{'visibility': chartSetting === 'default' ? 'hidden' : 'visible'}"> Reset Chart</span>
          <button class="button" style="margin-top: 15px" (click)="downloadHistory()"> Download History</button>
        </div>
        <i class="site-icon-maximise primary-color pointer-cursor" *ngIf="!expanded" (click)="expandView('CHART')"></i>
        <i class="site-icon-minimise primary-color pointer-cursor" *ngIf="expanded" (click)="expandView('CHART')"></i>
      </div>
      <div class="card-body" *ngIf="chartDataLoaded && (chartData.chartSeries.data.length !== 0 || chartDatas.length !== 0)">
        <app-chart-page *ngIf="chartType === 'single'" [indexID]="'iboxx'" [chartType]="chartType" [chartData]="chartData" [timePeriod]="currentPeriod"></app-chart-page>
        <app-chart-page *ngIf="chartType === 'multi'" [indexID]="'iboxx'" [chartType]="chartType" [chartData]="chartDatas" [timePeriod]="currentPeriod"></app-chart-page>
      </div>
      <div class="card-body" *ngIf="chartDataLoaded && chartData.chartSeries.data.length === 0 && chartDatas.length === 0">
        <div class="no-data-display">
          No Data to display
        </div>
      </div>
    </div>
  </div>
  <div class="sub-section" [ngStyle]="{'display': expanded ? 'inline' : 'flex'}">
    <div class="card index-profile-card" [ngStyle]="{'width': expanded ? '99%' : '50%', 'margin-top': expanded ? 0 : '5px'}"
         [hidden]="!visibleCards.includes('profile')">
      <div class="card-header">
        <span> Index Profile </span>
        <i class="site-icon-maximise primary-color pointer-cursor" *ngIf="!expanded" (click)="expandView('INDEX PROFILE')"></i>
        <i class="site-icon-minimise primary-color pointer-cursor" *ngIf="expanded" (click)="expandView('INDEX PROFILE')"></i>
      </div>
      <div class="card-body" style="padding: 0.5rem">
        <div class="section" *ngIf="!profileData && !profileLoading">
          No data to show
        </div>
        <app-skeleton-loader *ngIf="profileLoading" [loaderSize]="'small'" [loaderType]="'grid'"></app-skeleton-loader>
        <app-index-profile-page *ngIf="profileData" [profileData]="profileData" [expanded]="expanded"></app-index-profile-page>
      </div>
    </div>
    <div class="card index-performance-card" [ngStyle]="{'width': expanded ? '99%' : '50%', 'margin-top': expanded ? '0' : '5px'}"
         [hidden]="!visibleCards.includes('analytics')">
      <div class="card-header">
        <span> Index Performance & Analytics </span>
        <i class="site-icon-maximise primary-color pointer-cursor" *ngIf="!expanded" (click)="expandView('INDEX PERFORMANCE & ANALYTICS')"></i>
        <i class="site-icon-minimise primary-color pointer-cursor" *ngIf="expanded" (click)="expandView('INDEX PERFORMANCE & ANALYTICS')"></i>
      </div>
      <div class="card-body" *ngIf="response">
        <app-index-performance-analytics-page [indexType]="'iboxx'" [indexData]="response"></app-index-performance-analytics-page>
      </div>
      <div class="section" *ngIf="!response">
        No data to show
      </div>
    </div>
  </div>
  <div class="sub-section" *ngIf="response?.investmentType !== null &&
   (response?.investmentType.includes('ETFs_FUNDs') ||response?.investmentType.includes('Standardized_TRS') ||response?.investmentType.includes('Futures'))">
    <div class="card index-constituent-card" [hidden]="!visibleCards.includes('constituent')" [ngStyle]="{'margin-top': expanded ? '0' : '5px'}">
      <div class="card-header" style="display: flex">
        <div style="width: 100%; padding-right: 15px">
          <span> Index Constituents </span>
          <button class="button" style="float: right" *ngIf="(response?.investmentType.includes('Standardized_TRS') || response?.investmentType.includes('Futures')) && constituentData" (click)="downloadConstituentData()"> Download Constituents</button>
        </div>
        <i class="site-icon-maximise primary-color pointer-cursor" *ngIf="!expanded" (click)="expandView('CONSTITUENT')"></i>
        <i class="site-icon-minimise primary-color pointer-cursor" *ngIf="expanded" (click)="expandView('CONSTITUENT')"></i>
      </div>
      <div class="card-body">
        <div class="section" *ngIf="!constituentData && !profileLoading">
          No data to show
        </div>
        <app-skeleton-loader *ngIf="profileLoading" [loaderSize]="'medium'" [loaderType]="'grid'"></app-skeleton-loader>
        <app-index-costituent-page *ngIf="constituentData" [indexType]="'iboxx'" [isTRS]="response?.investmentType.includes('Standardized_TRS') || response?.investmentType.includes('Futures')" [constituentData]="constituentData"></app-index-costituent-page>
      </div>
    </div>
  </div>
</div>
<lib-ihsm-alert-notification class="alert-box index-details" *ngIf="showAlert1" [message]="alert1" (close)="closeAlert('alert1')" [messageType]="alertType"></lib-ihsm-alert-notification>
<lib-ihsm-alert-notification class="alert-box chart-data" *ngIf="showAlert2" [message]="alert2" (close)="closeAlert('alert2')" [messageType]="alertType"></lib-ihsm-alert-notification>
<lib-ihsm-alert-notification class="alert-box constituent-data" *ngIf="showAlert3" [message]="alert3" (close)="closeAlert('alert3')" [messageType]="alertType"></lib-ihsm-alert-notification>
<lib-ihsm-alert-notification class="alert-box headline-data" *ngIf="indexNotInHeadline" [message]="indexNotFoundMsg"
                             (close)="closeAlert('indexNotFoundMsg')" [messageType]="'info'"></lib-ihsm-alert-notification>
